<template>
  <PrimeBadge
    :pt="props.pt"
    :unstyled="true"
    class="meridia-badge"
    :class="[computedTypeClass, computedSizeClass]"
  >
    <template v-if="slots.default">
      <slot />
    </template>
    <span v-else>
      {{ props.value }}
    </span>
  </PrimeBadge>
</template>

<script setup lang="ts">
import { BadgePassThroughOptions, BadgeSlots } from 'primevue';
import { PassThrough } from '@primevue/core';
import { computed } from 'vue';
import { BadgeSize, BadgeType } from './types';
import PrimeBadge from 'primevue/badge';

const props = withDefaults(
  defineProps<{
    value?: number | string;
    size?: `${BadgeSize}`;
    type?: `${BadgeType}`;
    pt?: PassThrough<BadgePassThroughOptions>;
  }>(),
  {
    value: 0,
    size: BadgeSize.SMALL,
    type: BadgeType.NEUTRAL,
  }
);

const slots = defineSlots<BadgeSlots>();

const computedTypeClass = computed(() => {
  return {
    neutral: props.type === BadgeType.NEUTRAL,
    success: props.type === BadgeType.SUCCESS,
    failure: props.type === BadgeType.FAILURE,
  };
});

const computedSizeClass = computed(() => {
  return {
    small: props.size === BadgeSize.SMALL,
    big: props.size === BadgeSize.BIG,
  };
});
</script>

<style lang="scss" scoped>
.meridia-badge {
  @apply text-neutral-text-negative-title radius-full px-2 inline-flex flex-shrink-0 flex-wrap content-center items-center justify-center transition-all duration-200;

  &.neutral {
    @apply bg-neutral-surface-strong;
  }

  &.success {
    @apply bg-primary-surface-default;
  }

  &.failure {
    @apply bg-critical-surface-default;
  }

  &.small {
    @apply text-caption-small h-m;
  }

  &.big {
    @apply text-caption-base h-xl;
  }
}
</style>
